export default abstract class DataGridRequest<TModel> {
    abstract readonly Url: string;
}
